import { z } from 'zod/v4';
import { privacyLevelEnum as privacyLevelSchema, type PrivacyLevel } from '../enums/index';

export const updateProfileSchema = z.object({
  firstName: z.string()
    .min(1, 'Имя не может быть пустым')
    .max(50, 'Имя слишком длинное (максимум 50 символов)')
    .optional(),
  lastName: z.string().max(50, 'Фамилия слишком длинная (максимум 50 символов)').optional().nullable(),
  about: z.string().max(500, 'Описание слишком длинное (максимум 500 символов)').optional().nullable(),
  email: z.string().email('Некорректный формат email').optional().nullable(),
  phone: z.string().max(20, 'Номер телефона слишком длинный (максимум 20 символов)').optional().nullable(),
  socialLinks: z.record(
    z.string(),
    z.string().max(500, 'Ссылка слишком длинная (максимум 500 символов)').nullable(),
  ).optional(),
  isPublicProfile: z.boolean().optional(),
  countryId: z.number().int().positive().nullable().optional(),
});

export const updatePrivacySchema = z.object({
  emailPrivacy: privacyLevelSchema.optional(),
  phonePrivacy: privacyLevelSchema.optional(),
  aboutPrivacy: privacyLevelSchema.optional(),
  socialLinksPrivacy: privacyLevelSchema.optional(),
});

export const updateAvatarSchema = z.object({
  fileId: z.number({ message: 'ID файла обязателен' })
    .int('ID файла должен быть целым числом')
    .positive('ID файла должен быть положительным'),
});

export type UpdateProfileDto = z.infer<typeof updateProfileSchema>;
export type UpdatePrivacyDto = z.infer<typeof updatePrivacySchema>;
export type UpdateAvatarDto = z.infer<typeof updateAvatarSchema>;

// Re-export PrivacyLevel for backward compatibility
export type { PrivacyLevel };
